export var TEAM_EVENT_NAME;
(function (TEAM_EVENT_NAME) {
    TEAM_EVENT_NAME["TEAM_LIST"] = "TEAM_LIST";
    TEAM_EVENT_NAME["UPDATE_TEAM"] = "UPDATE_TEAM";
    TEAM_EVENT_NAME["TRANSFER_TEAM"] = "TRANSFER_TEAM";
    TEAM_EVENT_NAME["ADD_TEAM_MEMBERS"] = "ADD_TEAM_MEMBERS";
    TEAM_EVENT_NAME["REMOVE_TEAM_MEMBERS"] = "REMOVE_TEAM_MEMBERS";
    TEAM_EVENT_NAME["UPDATE_TEAM_MEMBERS"] = "UPDATE_TEAM_MEMBERS";
    TEAM_EVENT_NAME["LEAVE_TEAM"] = "LEAVE_TEAM";
    TEAM_EVENT_NAME["JOIN_TEAM"] = "JOIN_TEAM";
})(TEAM_EVENT_NAME || (TEAM_EVENT_NAME = {}));
